// Modules
import { Store, select } from '@ngrx/store';
import { formatDate } from '../../../../../../shared/utils/date-utils';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';

//Interfaces
import { IAccidentDetail } from '@accidents/shared/interfaces/accidents';

// Store
import { ModuleState } from '@app/modules/accidents/store/reducers';
import * as DetailAccidentSelectors from '@accidents/store/selectors/detail-accident.selectors';

@Component({
    selector: 'sbi-cot-back-policy-data-tab',
    templateUrl: './policy-data-tab.component.html',
    styleUrls: ['./policy-data-tab.component.scss'],
    standalone: false
})
export class PolicyDataTabComponent implements OnInit {
  public policyDataForm: FormGroup;
  public accidentDetail: IAccidentDetail;

  // Servicio detalle siniestros
  private _accidentDetail$ = this._store$.pipe(
    select(DetailAccidentSelectors.selectDetailAccident)
  );

  constructor(
    private _formBuilder: FormBuilder,
    private _store$: Store<ModuleState>
  ) {}

  ngOnInit() {
    this._parseDatosAccidente();

    this._setDatosPolizaForm();

    this._parseDatosPoliza();
  }

  // Private method to set the form data
  private _parseDatosAccidente(): void {
    this._accidentDetail$.subscribe((accidentRequest: IAccidentDetail) => {
      if (accidentRequest) {
        this.accidentDetail = accidentRequest;
      }
    });
  }

  // Private method for build the form
  private _setDatosPolizaForm(): void {
    this.policyDataForm = this._formBuilder.group({
      numeroPoliza: [{ value: '', disabled: true }],
      numeroCarpeta: [{ value: '', disabled: true }],
      origenDenuncia: [{ value: '', disabled: true }],
      idContractManagement: [{ value: '', disabled: true }],
      fechaInicioVigenciaPoliza: [{ value: '', disabled: true }],
      fechaFinVigenciaPoliza: [{ value: '', disabled: true }],
      nombrePaquete: [{ value: '', disabled: true }],
      nombreCobertura: [{ value: '', disabled: true }],
      slipReaseguro: [{ value: '', disabled: true }],
      nombreCorredor: [{ value: '', disabled: true }],
      tipoEndoso: [{ value: '', disabled: true }],
      tipoPoliza: [{ value: '', disabled: true }],
      coaseguro: [{ value: '', disabled: true }],
      numeroOmega: [{ value: '', disabled: true }],
      autoCortesia: [{ value: '', disabled: true }],
      coberturaGranizo: [{ value: '', disabled: true }],
      codigoAsegurado: [{ value: '', disabled: true }],
      nombreAsegurado: [{ value: '', disabled: true }],
      autoDeducible: [{ value: '', disabled: true }],
      espirometria: [{ value: '', disabled: true }],
    });
  }

  // Private method to set the form data
  private _parseDatosPoliza(): void {
    // Get form data
    const numeroPoliza = this.policyDataForm.get('numeroPoliza');
    const numeroCarpeta = this.policyDataForm.get('numeroCarpeta');
    const idContractManagement = this.policyDataForm.get(
      'idContractManagement'
    );
    const fechaInicioVigenciaPoliza = this.policyDataForm.get(
      'fechaInicioVigenciaPoliza'
    );
    const fechaFinVigenciaPoliza = this.policyDataForm.get(
      'fechaFinVigenciaPoliza'
    );
    const nombrePaquete = this.policyDataForm.get('nombrePaquete');
    const nombreCobertura = this.policyDataForm.get('nombreCobertura');
    const slipReaseguro = this.policyDataForm.get('slipReaseguro');
    const nombreCorredor = this.policyDataForm.get('nombreCorredor');
    const tipoEndoso = this.policyDataForm.get('tipoEndoso');
    const tipoPoliza = this.policyDataForm.get('tipoPoliza');
    const coaseguro = this.policyDataForm.get('coaseguro');
    const numeroOmega = this.policyDataForm.get('numeroOmega');
    const autoCortesia = this.policyDataForm.get('autoCortesia');
    const coberturaGranizo = this.policyDataForm.get('coberturaGranizo');

    const codigoAsegurado = this.policyDataForm.get('codigoAsegurado');
    const nombreAsegurado = this.policyDataForm.get('nombreAsegurado');
    const autoDeducible = this.policyDataForm.get('autoDeducible');
    const espirometria = this.policyDataForm.get('espirometria');

    // Rellenamos el Estado
    if (this.accidentDetail.datosPoliza) {
      numeroPoliza.patchValue(this.accidentDetail.datosPoliza.nroPoliza);
      if (this.accidentDetail.datosPoliza.nroPoliza) {
        numeroCarpeta.patchValue(
          this.accidentDetail.datosPoliza.nroPoliza.substring(0, 13)
        );
      }
      idContractManagement.patchValue(
        this.accidentDetail.datosPoliza.contractId
      );
      fechaInicioVigenciaPoliza.patchValue(
        formatDate(
          this.accidentDetail.datosPoliza.fechaInicioVigenciaPoliza,
          'dd/MM/yyyy'
        )
      );
      fechaFinVigenciaPoliza.patchValue(
        formatDate(this.accidentDetail.datosPoliza.fechaFinVigenciaPoliza, 'dd/MM/yyyy')
      );

      if (this.accidentDetail.datosPoliza.nombrePaquete) {
        nombrePaquete.patchValue(
          this.accidentDetail.datosPoliza.codigoPaquete +
            '-' +
            this.accidentDetail.datosPoliza.nombrePaquete
        );
      } else {
        nombrePaquete.patchValue(this.accidentDetail.datosPoliza.codigoPaquete);
      }

      nombreCobertura.patchValue(
        this.accidentDetail.datosPoliza.nombreCobertura
      );
      slipReaseguro.patchValue(this.accidentDetail.datosPoliza.slipReaseguro);
      nombreCorredor.patchValue(this.accidentDetail.datosPoliza.nombreCorredor);
      tipoEndoso.patchValue(this.accidentDetail.datosPoliza.tipoEndoso);
      tipoPoliza.patchValue(this.accidentDetail.datosPoliza.tipoPoliza);
      coaseguro.patchValue(this.accidentDetail.datosPoliza.coaseguro);
      numeroOmega.patchValue(this.accidentDetail.datosPoliza.numeroOmega);

      if (this.accidentDetail.datosPoliza.autoCortesia) {
        const aux = this.accidentDetail.datosPoliza.autoCortesia.toLowerCase();
        if (aux === 'no') {
          autoCortesia.patchValue(false);
        } else {
          autoCortesia.patchValue(true);
        }
      } else {
        autoCortesia.patchValue(false);
      }
      if (this.accidentDetail.datosPoliza.coberturaGranizo) {
        const aux =
          this.accidentDetail.datosPoliza.coberturaGranizo.toLowerCase();
        if (aux === 'no') {
          coberturaGranizo.patchValue(false);
        } else {
          coberturaGranizo.patchValue(true);
        }
      } else {
        coberturaGranizo.patchValue(false);
      }
      codigoAsegurado.patchValue(
        this.accidentDetail.datosPoliza.codigoAsegurado
      );
      nombreAsegurado.patchValue(
        this.accidentDetail.datosPoliza.nombreAsegurado
      );
      autoDeducible.patchValue(this.accidentDetail.datosPoliza.autoDeducible);
      if (
        this.accidentDetail.conductorMomentoSiniestro &&
        this.accidentDetail.conductorMomentoSiniestro.examenDeAlcoholemia
      ) {
        espirometria.patchValue(
          this.accidentDetail.conductorMomentoSiniestro.examenDeAlcoholemia.indexOf(
            '1-'
          ) == 0
        );
      } else {
        espirometria.patchValue(false);
      }
    }
  }
}
